import ReactNative from '../services/react-native';

export enum DeviceType {
  DESKTOP = 'desktop',
  TABLET = 'tablet',
  MOBILE = 'mobile',
  UNKNOWN = 'unknown'
}

export function getDeviceType() {
  return ReactNative.isReactNativeWebView() ? DeviceType.MOBILE : DeviceType.DESKTOP;
}
